module.exports = __webpack_public_path__ + "img/logo.dfb8596c.png";